import { type PayloadAction, createSlice } from "@reduxjs/toolkit"

import { IOneVerifyCoverageOverride } from "@common-shared/types/responseData/oneVerifyResponseData.types.ts"

import type { ICoverageOverridesState } from "../../types/state.types.ts"

const initialState: ICoverageOverridesState = {
    items: [],
    selectedPolicyOverride: null,
}

const coverageOverridesSlice = createSlice({
    name: "coverageOverrides",
    initialState,
    reducers: {
        coverageOverridesReset: () => initialState,

        coverageOverridesSetSelectedPolicyOverride: (
            state,
            action: PayloadAction<IOneVerifyCoverageOverride | null>,
        ) => {
            state.selectedPolicyOverride = action.payload
        },
    },
})

export const {
    coverageOverridesReset,
    coverageOverridesSetSelectedPolicyOverride,
} = coverageOverridesSlice.actions

export const coverageOverridesReducer = coverageOverridesSlice.reducer
